import { ListOrderService } from 'application/services/list-order'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListOrder = new ListOrderService(api)
